export default __webpack_public_path__ + "static/media/product1.1fd4b0e2.png";